module.exports = __webpack_public_path__ + "media/images/lb/658-da40c3f81fbee5e9a0ee0edb99bdf384.svg";